import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'negate',
  standalone: true,
})
export class NegatePipe implements PipeTransform {
  transform(value: BooleanInput): boolean {
    return !coerceBooleanProperty(value);
  }
}
